module.exports = __webpack_public_path__ + "img/Deletevideo.21196c06.svg";